import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { IconLabelSelector } from "@/components/uis/IconLabelSelector";
import styles from "./styles.module.css";
export const SUMMARY_PERIODS = ["today", "3days", "1week", "monthly"] as const;
export type SummaryPeriod = (typeof SUMMARY_PERIODS)[number];
const PERIOD_LABELS: Record<SummaryPeriod, string> = {
  today: "当日",
  "3days": "3日間",
  "1week": "1週間",
  monthly: "月間"
};
const PERIOD_ROWS: SummaryPeriod[][] = [["today", "3days", "1week"], ["monthly"]];
type PeriodSelectBoxProps = {
  selectedPeriod: SummaryPeriod;
  onChangePeriod: (period: SummaryPeriod) => void;
};

/**
 * ヘッダーの期間セレクターコンポーネント。
 * クリックすると期間選択モーダルが表示される。
 */
export const PeriodSelectBox: FC<PeriodSelectBoxProps> = t0 => {
  const $ = _c(18);
  const {
    selectedPeriod,
    onChangePeriod
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpen = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] !== onChangePeriod) {
    t3 = period => {
      setIsOpen(false);
      onChangePeriod(period);
    };
    $[2] = onChangePeriod;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSelect = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <InputLabel id="period-select-label"><IconLabelSelector type="period" iconColor="primary" /></InputLabel>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = SUMMARY_PERIODS.map(_temp);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== selectedPeriod) {
    t6 = <FormControl className={styles.form}>{t4}<Select labelId="period-select-label" value={selectedPeriod} onClick={handleOpen} onOpen={handleOpen} onClose={handleClose} className={styles.select} open={false}>{t5}</Select></FormControl>;
    $[6] = selectedPeriod;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handleSelect) {
    t7 = PERIOD_ROWS.map((row, rowIndex) => <Box key={rowIndex} display="flex" gap="24px">{row.map(period_1 => <Card key={period_1} className={styles.card}><CardActionArea className={styles.cardAction} onClick={() => handleSelect(period_1)}><Typography variant="h1" component="div" color="#1C2E2E">{PERIOD_LABELS[period_1]}</Typography></CardActionArea></Card>)}</Box>);
    $[8] = handleSelect;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <Box display="flex" justifyContent="center" alignItems="center" width="100vw" height="100vh" onClick={handleClose}><Box className={styles.paper} onClick={_temp2}>{t7}</Box></Box>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isOpen || $[13] !== t8) {
    t9 = <Modal open={isOpen} onClose={handleClose}>{t8}</Modal>;
    $[12] = isOpen;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <>{t6}{t9}</>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
function _temp(period_0) {
  return <MenuItem key={period_0} value={period_0}>{PERIOD_LABELS[period_0]}</MenuItem>;
}
function _temp2(e) {
  return e.stopPropagation();
}